import "core-js/modules/es6.function.name";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Modal', {
    ref: "modal",
    staticClass: "prodect_modal",
    attrs: {
      "width": 400,
      "title": _vm.title
    },
    model: {
      value: _vm.modalVisible,
      callback: function callback($$v) {
        _vm.modalVisible = $$v;
      },
      expression: "modalVisible"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "myform",
    attrs: {
      "model": _vm.data,
      "rules": _vm.rules,
      "label-width": 100,
      "showMessage": false,
      "autocomplete": "off",
      "novalidate": ""
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "product_name",
      "label": "产品名称"
    }
  }, [_c('IInput', {
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('product_name');
      }
    },
    model: {
      value: _vm.data.product_name,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "product_name", $$v);
      },
      expression: "data.product_name"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "prop": "product_type",
      "label": "产品类型"
    }
  }, [_c('IInput', {
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('product_type');
      }
    },
    model: {
      value: _vm.data.product_type,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "product_type", $$v);
      },
      expression: "data.product_type"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "prop": "license_interface",
      "label": "激活接口"
    }
  }, [_c('Select', {
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('license_interface');
      }
    },
    model: {
      value: _vm.data.license_interface,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "license_interface", $$v);
      },
      expression: "data.license_interface"
    }
  }, _vm._l(_vm.licenseinterfaces, function (item, index) {
    return _c('Option', {
      key: index,
      attrs: {
        "value": item.name
      }
    }, [_vm._v(_vm._s(item.description))]);
  }), 1)], 1), _c('FormItem', {
    attrs: {
      "prop": "affect",
      "label": "功能定义"
    }
  }, [_c('IInput', {
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "on-change": function onChange($event) {
        return _vm.validate('affect');
      }
    },
    model: {
      value: _vm.data.affect,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "affect", $$v);
      },
      expression: "data.affect"
    }
  })], 1), _vm.from !== 'update' ? _c('FormItem', {
    attrs: {
      "label": "是否停用",
      "required": ""
    }
  }, [_c('RadioGroup', {
    attrs: {
      "disabled": _vm.loading
    },
    model: {
      value: _vm.data.product_status,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "product_status", $$v);
      },
      expression: "data.product_status"
    }
  }, [_c('Radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("是")]), _c('Radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("否")])], 1)], 1) : _vm._e()], 1), _c('template', {
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "loading": _vm.loading,
      "disabled": !_vm.isFormValid
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("确定")]), _c('Button', {
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])], 1)], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };